import { render, staticRenderFns } from "./SessionWarningModal.vue?vue&type=template&id=35fb3d0d"
import script from "./SessionWarningModal.vue?vue&type=script&lang=js"
export * from "./SessionWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports